import {Directive, ElementRef, HostListener, OnInit} from "@angular/core";
import {Http, RequestOptions} from "@angular/http";
import {environment} from "../environments/environment";

@Directive({
  selector: "[logOff]",
})
export class LogOffDirective implements OnInit {
  constructor(
    private http: Http,
    private el: ElementRef,
  ) {}

  ngOnInit() {
    if (this.el.nativeElement.tagName === "A") {
      this.el.nativeElement.href = "javascript:void(0);";
    }
  }

  @HostListener("click", ["$event"])
  click(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.http.post(
      `${environment.httpBase}/auth/logoff`,
      {},
      new RequestOptions({withCredentials: true})
    )
      .toPromise()
      .catch((error) => {
        console.error(error);
      });

    return false;
  }
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/log-off.directive.ts